import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import UserInfo from "../../../components/UserInfo";
import LogOut from "../../../components/LogOut";
import QrCodeScanner from "../../../components/QrCodeScanner";
import RestoreAccessButton from "../../../components/RestoreAccess";
import RecentCustomers from "../../../components/RecentCustomers";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/auth";
import { useTranslation } from "../../../i18n";

export default function AdminSidebar({ onNavigate }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  return (
    <div className="flex flex-col space-y-3 xl:space-y-4 h-full min-w-fit">
      <UserInfo />
      {user?.role === 2 && (
        <Button
          variant="secondary"
          onClick={() => navigate("/dashboard/super/customers")}
        >
          {t("admin.managerPanel")}
        </Button>
      )}
      <QrCodeScanner isActive={true} />
      <RestoreAccessButton
        onClick={() => {
          navigate("restore-access");
          onNavigate?.();
        }}
        isActive={false}
      />
      <RecentCustomers
        onClick={() => {
          navigate("recent-customer");
          onNavigate?.();
        }}
      />
      <LogOut />
    </div>
  );
}
